import { VERNACULAR_DEFAULT_MESSAGES } from "constants/vernacularConstants";


interface ValidationReturnType{ error: string, hasError: boolean };

export const validateGiftCardPinField = (value:number|null, errors?: {required: string, invalid: string}):ValidationReturnType => {
  let error = "";
  let hasError = false;
  if (!value) {
    error = errors?.required || VERNACULAR_DEFAULT_MESSAGES.REQUIRED;
    hasError = true;
  } else if (value?.toString()?.length < 6) {
    //show error if giftcard pin is less than 6 digits
    error = "Invalid PIN";
    hasError = true;
  }
  else {
    error = "";
  }

  return {
    error,
    hasError,
  };
};
